export default __webpack_public_path__ + "static/media/VF_condiciones_generales_recurso_LEP_2025.6397a8b7.pdf";